<div id="addStoreProductModal">
  <div class="tw-flex tw-flex-row tw-items-center">
    <h3 id="storeModalTitle" class="tw-text-center tw-flex-1">Add Widget</h3>
    <button
      type="button"
      mat-icon-button
      class="close tw-mr-[5px]"
      (click)="close()"
      aria-label="Close this modal"
    >
      <streamline-icon name="close" width="12" height="12"></streamline-icon>
    </button>
  </div>
  <mat-dialog-content>
    <section id="productList" class="product-grid widget-grid">
      <div class="professional-content panel panel-default border-container">
        <ul class="panel-body template-list">
          @for (product of products; track product) {
            <li id="storeProduct" class="template-card">
              <!-- Template Image -->
              <div class="template-image" (click)="select(product)">
                <img
                  loading="lazy"
                  src="{{ product.imageUrl }}"
                  class="img-responsive"
                  alt="{{ product.imageAlt || product.name }}"
                />
                <span class="cta">Use this Widget</span>
                <span class="template-fx"></span>
              </div>
              <!-- Template Details -->
              <div class="template-details">
                <div class="template-title">
                  <span id="productName">{{
                    product.name | slice: 0 : 25
                  }}</span>
                </div>
                <div class="template-button">
                  <button
                    mat-flat-button
                    color="primary"
                    class="add-button"
                    id="{{ slugify(product.name) }}"
                    (click)="select(product); $event.stopPropagation()"
                    aria-label="Add {{ product.name }}"
                  >
                    <mat-icon svgIcon="add" aria-hidden="true"></mat-icon>
                  </button>
                </div>
              </div>
            </li>
          }
        </ul>
        <!--panel-body-->
      </div>
      <!--panel-->
    </section>
  </mat-dialog-content>
  <mat-dialog-actions align="start">
    @if (_addWidgetByUrl) {
      <button
        rv-button
        variant="secondary"
        id="addWidgetByUrl"
        (click)="_addWidgetByUrl()"
      >
        Add a Custom Rise Widget
      </button>
    }
  </mat-dialog-actions>
</div>
